<nav>
  <mat-toolbar style="align-items: normal" id="header">
    <div class="container">
      <div class="row">

        <div class="col">
          <img id="logo-img" src="assets/IFenua-full-logo.svg" alt="IFenua logo" height="200px" class="img-fluid"/>
        </div>

        <span class="toolbar-spacer"></span>

        <div class="col" *ngIf="isShowUserSpaceButton">
          <button class="btn btn-outline-primary">S'inscrire</button>
          <button class="btn btn-outline-primary">Se connecter</button>
        </div>

      </div>
    </div>
  </mat-toolbar>
</nav>


<div id="sub-header">
</div>


<div id="main-content" class="container-fluid">

  <div class="container">
    <div *ngIf="!isProduction" class="alert alert-info">Environment : <strong>{{envName}}</strong></div>
  </div>

  <ng-container *ngIf="!isUseSimpleTemplate; else elseSimpleTemplate">
    <section id="about">
      <div class="container">
        <h1>IFenua</h1>
        <p>IFenua est une société de service répondant aux besoins d'autres entreprises dans le cadre du passage au numérique.</p>
        <p>Nous sommes expert dans le domaine des applications web, et mettons tout en oeuvre afin de porter les projets de chaques clients jusqu'à la fin.</p>
      </div>
    </section>


    <section id="services">
      <div class="container">
        <h2>Services</h2>
        <p>
          Nous proposons des solutions d'applications sur mesure répondant aux besoins du client.
        </p>
      </div>
    </section>


    <section id="technologies">
      <div class="container">
        <h2>Technologies</h2>
        <p>Afin de mener à bien nos missions, nous utilisons des technologies robustes et toujours à jours.</p>

      </div>
    </section>
  </ng-container>

  <ng-template #elseSimpleTemplate>
    <section id="alternative-section">
      <div class="container">
        <h1>IFenua</h1>
        <p>IFenua est une entreprise de prestations informatique spécialisée dans la création d'applications numériques.</p>
        <p>Créée en 2017 par un étudiant diplômé d'une licence informatique de l'Université de la Polynésie Française ; puis diplômé d'un master en France en tant qu'expert en informatique et systèmes d'information.</p>
        <p>Curieux des nouvelles technologies, nous essayons de mettre en place des projets de recherche et développement dans le but de conseiller au mieux nos clients ainsi que de répondre à leurs attentes.</p>
        <p>IFenua se concentre principalement sur la création d’application web à destination de professionnels afin de leur permettre de gérer leurs activités plus facilement et plus rapidement.</p>
        <br>
        <p class="text-muted"><span class="font-italic">PS: Nous améliorerons cette description au fil du temps !</span> 🙂</p>
      </div>
    </section>
  </ng-template>


  <section id="technologies-logo">
    <div class="container">

      <div class="card-deck">

        <div class="card" *ngFor="let technology of listOfTechnologiesIconsToDisplay">
          <ng-container *ngIf="technology.link; else technologyNoLinkTpl">
            <a [href]="technology.link" rel="noreferrer" target="_blank">
              <img class="card-img-top" [src]="'assets/vendors-logo/' + technology.iconName" [alt]="technology.imgAlt" height="100"/>
            </a>
          </ng-container>

          <ng-template #technologyNoLinkTpl>
            <img class="card-img-top" [src]="'assets/vendors-logo/' + technology.iconName" [alt]="technology.imgAlt" height="100"/>
          </ng-template>

          <div class="card-body">
            <h5 class="card-title" *ngIf="technology.title">{{ technology.title }}</h5>
            <p class="card-text" *ngIf="technology.description">{{ technology.description }}</p>
          </div>
        </div>

      </div>

    </div>
  </section>

  <section id="contact">
    <div class="container">
      <h2>Contact</h2>

      <div class="row">

        <div class="col-sm-12 col-md-8">

          <ngx-spinner
            bdColor="rgba(0, 0, 0, 0.8)"
            size="medium"
            color="#fff"
            type="triangle-skew-spin"
            [fullScreen]="false">
            <p style="color: white; margin-top: 15px">Envoi en cours...</p>
          </ngx-spinner>

          <form [formGroup]="contactForm" novalidate #formDirective="ngForm" (submit)="sendFormContact(formDirective)">

            <div class="row">

              <div class="col-12">
                <div class="row">
                  <div class="col">
                    <mat-form-field class="full-width" appearance="outline">
                      <mat-label>Nom</mat-label>
                      <input matInput type="text" autocomplete="off" required placeholder="Ex: John Doe" formControlName="name">
                    </mat-form-field>
                  </div>
                  <div class="col">
                    <mat-form-field class="full-width" appearance="outline">
                      <mat-label>Téléphone</mat-label>
                      <input matInput type="tel" autocomplete="off" placeholder="Ex: 12.12.34.56" formControlName="phone">
                    </mat-form-field>
                  </div>
                  <div class="col">
                    <mat-form-field class="full-width" appearance="outline">
                      <mat-label>Email</mat-label>
                      <input matInput type="email" autocomplete="off" required placeholder="Ex: john.doe@domain.pf" formControlName="email">
                    </mat-form-field>
                  </div>
                </div>
              </div>


              <div class="col-12">
                <div class="row">
                  <div class="col-12">
                    <mat-form-field class="full-width" appearance="outline">
                      <mat-label>Sujet</mat-label>
                      <input matInput type="text" autocomplete="off" required placeholder="Ex: Devis pour une application web" formControlName="subject">
                    </mat-form-field>
                  </div>
                </div>
              </div>


              <div class="col-12">
                <div class="row">
                  <div class="col">
                    <mat-form-field class="full-width" appearance="fill">
                      <mat-label>Message</mat-label>
                      <textarea
                        matInput
                        required
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize"
                        placeholder="Votre message"
                        cdkAutosizeMinRows="10"
                        formControlName="message"></textarea>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="row">
                  <div class="col-12">
                    <button type="submit"
                            class="btn btn-outline-success btn-block"
                            [disabled]="contactForm.invalid || contactForm.disabled">Envoyer ! 📧</button>
                  </div>
                </div>
              </div>

            </div>

          </form>
        </div>

        <div class="col-sm-12 col-md-4 text-justify">
          <p>Vous avez un projet ou besoin d'informations, n'hésitez pas à nous contacter !</p>
          <p>Ou par email : <a href="mailto:contact@ifenua.pf" (click)="onClickMailto()">contact@ifenua.pf</a></p>
          <p>Ou par courrier : BP 380 003 - 98703 Punaauia</p>
        </div>

      </div>

    </div>
  </section>

</div>

<div id="footer">
  <footer>
    <div class="container">
      <p class="text-center">
        © Développé par <strong>IFenua</strong> &nbsp; | &nbsp;
        100% <img src="assets/pf_flag.svg" alt="Drapeau de la Polynésie Française" width="38" height="25"> &nbsp; | &nbsp;
        Built with <a href="https://www.jetbrains.com/" rel="noreferrer" target="_blank"><img src="assets/vendors-logo/jetbrains-variant-3.svg" alt="Logo Jetbrain" width="30" height="35"></a>
      </p>
    </div>
  </footer>
</div>


<ng-template #materialSnackBarSuccessTpl>

  <div class="text-center row">
    <div class="col-2"><i class="fas fa-check-circle"></i></div>
    <div class="col-10">Le formulaire de contact a bien été envoyé !</div>
  </div>

</ng-template>

<ng-template #materialSnackBarFailTpl>

  <div class="text-center">
    <div class="col-2 align-middle"><i class="fas fa-times-circle fa-3x"></i></div>
    <div class="col-10">
      Il y a eu un problème lors de l'envoi du formulaire de contact ! Essayer de nous envoyer un email ?
    </div>
  </div>

</ng-template>
